var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadBlockedWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 6.66675C17.363 6.66675 14.7851 7.44873 12.5925 8.91382C10.3998 10.3789 8.69086 12.4613 7.68169 14.8976C6.67253 17.334 6.40848 20.0149 6.92295 22.6013C7.43742 25.1877 8.7073 27.5635 10.572 29.4282C12.4367 31.2929 14.8125 32.5627 17.3989 33.0772C19.9853 33.5917 22.6662 33.3276 25.1025 32.3185C27.5389 31.3093 29.6213 29.6003 31.0863 27.4077C32.5514 25.215 33.3334 22.6372 33.3334 20.0001C33.3334 18.2491 32.9885 16.5153 32.3185 14.8976C31.6484 13.28 30.6663 11.8101 29.4282 10.572C28.1901 9.33388 26.7202 8.35175 25.1025 7.68169C23.4849 7.01162 21.751 6.66675 20.0001 6.66675ZM20.0001 30.6667C17.1711 30.6667 14.458 29.5429 12.4576 27.5426C10.4572 25.5422 9.33342 22.8291 9.33342 20.0001C9.33047 17.6312 10.1241 15.3301 11.5868 13.4667L26.5334 28.4134C24.67 29.8761 22.369 30.6697 20.0001 30.6667ZM28.4134 26.5334L13.4668 11.5867C15.3301 10.1241 17.6312 9.33047 20.0001 9.33341C22.8291 9.33341 25.5422 10.4572 27.5426 12.4576C29.5429 14.458 30.6667 17.1711 30.6667 20.0001C30.6697 22.369 29.8761 24.67 28.4134 26.5334Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadBlockedWhite);
export default __webpack_public_path__ + "static/media/road-blocked-white.a0d8a7a93063fefee40bd98e0cfadbab.svg";
export { ForwardRef as ReactComponent };